import { addValidator } from '@nelio/forms/validation';

addValidator( 'date' );
addValidator( 'time' );
addValidator( 'datetime' );
